import {createContext} from "react";

export const LocalizationContext = createContext(null);
